/* eslint-disable react/no-danger */
// @ts-nocheck
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Divider, Container, Box, makeStyles } from '@material-ui/core';
import Text from 'components/atoms/Text/Text';
import FullContainer from 'components/atoms/FullContainer/FullContainer';
import HeroSection from 'components/organisms/HeroSection/HeroSection';
import RowSection from 'components/organisms/RowSection/RowSection';
import Accordion from 'components/organisms/Accordion/Accordion';
import { handleExternal } from 'utils/urls';
import { useCurrentLanguage } from 'utils/customHooks';
import FeatureSectionRadio from 'components/organisms/FeatureSectionRadio/FeatureSectionRadio';
import ScrollableAnchor from 'react-scrollable-anchor';
import { CheckMore } from 'components/molecules/CheckMore/CheckMore';
import { PopupButton } from "react-calendly";
import { openScaduleWidget } from 'utils/openScaduleWidget';

const useStyles = makeStyles(theme => ({
  Wrapper: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      margin: '10px 0',
      '& >*': {
        cursor: 'pointer',
        display: 'inline-flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }
  },
  list: {
    paddingLeft: 15,
    margin: 0,
    lineHeight: 1.5,

    
    [theme.breakpoints.only('xs')]: {
      listStyle: 'none',
      padding: 0,
      lineHeight: 1.2
    }
  }
}));


// radio page with ability to schedule meeting
const RadioPromo = () => {
  const classes = useStyles();
  const content = useSelector(state => state.language.tv);
  const contentRadio = useSelector(state => state.language.radio.promo);
  const lng = useCurrentLanguage();
  const [categories, setCategories] = useState(contentRadio.faq.accordions);

  const heroData = useMemo(
    () => ({
      id: 'hero.id',
      heading: (
        <span dangerouslySetInnerHTML={{ __html: contentRadio.heroSection.heading }} />
      ),
      image: 'https://img.fastcast4u.com/react/radio/backcover.png',
      video: 'https://img.fastcast4u.com/react/radio/radio.mp4',
      isNoStrapi: true,
      buttons: [{
        label: contentRadio.heroSection.button,
        onClick: openScaduleWidget,
        color: 'secondary',
      }]
    }),
    // eslint-disable-next-line
    [content, lng],
  );

  const sections = useMemo(
    () => [
      {
        img: 'https://img.fastcast4u.com/react/home/device1',
        // noWebp: true,
        heading: contentRadio.rowSections[0].heading,
        content: (
          <ul className={classes.list}>
            <li>
              <span><b>Unlimited</b> Listeners & Transfer</span>
            </li>
            <li>
              <span><b>Live Stream</b> & <b>AutoDJ</b> mode</span>
            </li>
            <li>
              <span>Online Server <b>Control Panel</b></span>
            </li>
            <li>
              <span><b>Playlist</b> Scheduler & Management</span>
            </li>
            <li>
              <span>Detailed <b>Listeners Statistics</b></span>
            </li>
            <li>
              <span>Useful Radio <b>Server Addons</b></span>
            </li>
          </ul>
        ),
        contentReverse: true,
        button: {
          label: contentRadio.rowSections[0].button,
          onClick: openScaduleWidget,
          color: 'primary',
        },
      },
      {
        img: 'https://img.fastcast4u.com/react/radio/everest1',
        noWebp: true,
        heading: contentRadio.rowSections[1].heading,
        content: (
          <ul className={classes.list}>
            <li>
              <span><b>Unlimited disc</b> space for your audio library</span>
            </li>
            <li>
              <span>24/7 Radio Automation <b>Scheduler</b></span>
            </li>
            <li>
              <span>Smooth transition between <b>Live Broadcast</b></span>
            </li>
            <li>
              <span>Easy drag&drop <b>Playlist Management</b></span>
            </li>
          </ul>
        ),
        contentReverse: true,
      },
      {
        img: '',
        RadioPlayer: {
          src: 'https://fastcast4u.com/player/wydra',
          width: 400,
          height: 500, 
        },
        heading: contentRadio.rowSections[2].heading,
        content:
          <ul className={classes.list}>
            <li>
              <b>Customizable</b> Layout, Logo and Themes
            </li>
            <li>
              <b>Automatic Setup</b> of your WebPlayer Page
            </li>
            <li>
              <b>Social Media & Players</b> buttons
            </li>
            <li>
              <b>Website Radio Player</b> embed widget
            </li>
            <li>
              <b>Dynamic</b> Cover Art & Metadata
            </li>
            <li>
              Place for <b>Ads</b> or <b>your own content</b>
            </li>
          </ul>,           
        contentReverse: true,
        buttonReverse: true,
        button: {
          label: contentRadio.rowSections[2].button,
          onClick: () => {window.open('http://fastcast4u.com/player/wydra/', '_blank', "width=1000,height=610,left:50%,top: 50%")},
          color: 'primary',
          inNewWindow: true,
        },
      }
    ],
    [contentRadio, lng],
  );

  const featureData = useMemo(
    () => [
      {
        heading: contentRadio.features[0].heading,
        desc: contentRadio.features[0].desc,
        cards:[
          {
            title: contentRadio.features[0].cards[0].title,
            img: 'https://fastcast4u.com/images/app/tel1.png',
            desc: contentRadio.features[0].cards[0].desc
          },
          {
            title: contentRadio.features[0].cards[1].title,
            img: 'https://img.fastcast4u.com/react/radio/alexa-front.png',
            desc: contentRadio.features[0].cards[1].desc
          },
          {
            title: contentRadio.features[0].cards[2].title,
            img: 'https://img.fastcast4u.com/react/tvapp/tv1.png',
            desc: contentRadio.features[0].cards[2].desc
          }
        ],
        button: {
          label: contentRadio.features[0].button,
          href: '',
          onClick: openScaduleWidget
        }
      },
    ], [contentRadio],
  );

  // useEffect(() => {
  //   faqServices.getCategories().then(({ articles }) => {
  //     setCategories(...articles);
  //   });
  // }, []);
  
  return (
    <>
      <HeroSection left={false} data={heroData} />
      {/* <Modal active={modalActive} setActive={setModalActive}>
        {modalActive && <ReactPlayer playing={true} width='90vw' height='90vh' url={'https://img.fastcast4u.com/react/tv/promo.mp4'} controls/>}
      </Modal>
      <Box className={classes.Wrapper}>
        <Box onClick={checkOutMoreHandler}>
          <Text component='h6' color='primary'>Check out more</Text>
          <ArrowDown />
        </Box>
      </Box>
       */}
      <CheckMore />
      
      <FullContainer id="more" maxWidth="xl" overflowHidden>
        {sections.map((props, i) => (
          <React.Fragment key={i}>
            <RowSection {...props} long paddingRightNone reverse={i % 2 === 0} />
            <Divider variant="middle" />
          </React.Fragment>
        ))}
      </FullContainer>
      {featureData.map((data, i) => <>
        <FeatureSectionRadio data={data} />
        {!(i % 2) && <Divider variant="middle" />}
      </>)}
      <Container maxWidth="xl">
        <Text component="h2" variant="h3" mt={4} mb={6} align="center" fontWeight={500}>
          {contentRadio.faq.title}
        </Text>
        {categories && <Accordion data={categories} />}
      </Container>
    </>
  );
};

export default RadioPromo;
